import { ProductFeatureType } from '@/api/v1/billing/plans'

// The three visual tier families, shared by the billing plans page and the
// common pricing surfaces (pricing-grid, plan-finder) — lives in lib so
// common/ never imports from pages/. Variants of a tier are SKUs, resolved in
// plan-sku.ts; nothing here is keyed by a response column any more.
export const TIER_CONFIG = [
  {
    feature: ProductFeatureType.ONE,
    name: 'Starter',
    key: 'one',
  },
  {
    feature: ProductFeatureType.PRO,
    name: 'Business',
    key: 'pro',
    popular: true,
  },
  {
    feature: ProductFeatureType.MAX,
    name: 'Enterprise',
    key: 'max',
  },
]

export type TierConfig = (typeof TIER_CONFIG)[number]

export type ButtonAction =
  | 'subscribe'
  | 'currentPlan'
  | 'upgrade'
  | 'downgrade'
  | 'blocked'

export type ButtonState = {
  action: ButtonAction
  variant: 'default' | 'outline'
  disabled: boolean
  isCurrentPlan?: boolean
}
